// services/post.api.ts
import { Parameters } from '@app/models/Parameters';
import { post, get } from './http.api';
import {
  PostRequest,
  PostResponse,
  PostsByCategoryResponse,
  PostTableData,
  PostTableRow,
} from '@app/models/post/PostResponse';

export const getPostTableData = async (parameters: Parameters): Promise<PostTableData> => {
  try {
    const { data, status } = await get<any>('posts', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const posts: PostTableRow[] = data?.posts?.data?.map((post: any) => ({
      id: post?.id,
      title: post?.title,
      slug: post?.slug,
      post_category_id: post?.post_category_id,
      status: post?.status,
      display_date: post?.display_date,
    }));

    return {
      data: posts,
      pagination: {
        current: data.posts.current_page,
        pageSize: data.posts.per_page,
        total: data.posts.total,
      },
      status_options: data.status_options,
      category_options: data.category_options,
    };
  } catch (error: any) {
    console.error('Error fetching Posts:', error);
    throw error;
  }
};

export const createPost = async (): Promise<PostResponse> => {
  try {
    const { data, status } = await get<PostResponse>('posts/create', undefined, true);
    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error creating Post:', error);
    throw error;
  }
};

export const storePost = async (postData: PostRequest) => {
  try {
    const response = await post<any>('posts/create', postData, undefined, true);
    console.log(`Status: ${response.status}`, `Data:`, response.data);
    return response.data;
  } catch (error: any) {
    console.error('Error storing Post:', error);
    throw error;
  }
};

export const showPost = async (id: number) => {
  try {
    const { data, status } = await get<PostResponse>(`posts/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error showing Post:', error);
    throw error;
  }
};

export const editPost = async (id: number) => {
  try {
    const { data, status } = await get<PostResponse>(`posts/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error editing Post:', error);
    throw error;
  }
};

export const updatePost = async (id: number, postData: PostRequest) => {
  try {
    const { data, status } = await post<any>(`posts/${id}/edit`, postData, undefined, true);
    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error updating Post:', error);
    throw error;
  }
};

export const deletePost = async (id: number) => {
  try {
    const { data, status } = await post<any>(`posts/${id}`, { _method: 'DELETE' }, undefined, true);

    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error deleting Post:', error);
    throw error;
  }
};

export const uploadPostImage = async (images: File[]) => {
  try {
    const formData = new FormData();

    images.forEach((image) => {
      formData.append('images[]', image);
    });

    const response = await post<any>(
      'posts/upload-image',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    );

    console.log(`Status: ${response.status}`, `Data:`, response.data);
    return response.data;
  } catch (error: any) {
    console.error('Error uploading post images:', error);
    throw error;
  }
};

export const getPostsByCategory = async (category: string): Promise<PostsByCategoryResponse> => {
  console.log(`Requesting posts for category: ${category}`);
  try {
    const { data, status } = await get<PostsByCategoryResponse>(
      `posts/by-category?category=${category}`,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error fetching posts by category:', error);
    throw error;
  }
};
